import React from 'react';
import {
  Image,
  Box,
  Center,
} from '@chakra-ui/react';
import {
  Card, CardHeader, CardTitle, CardContent
} from "../../../../components/Card";

export default function Product({serviceName, serviceImg}) {
  return (
    <>
      <Box>
        <Card>
          <CardHeader>
            <CardTitle>{ serviceName }</CardTitle>
          </CardHeader>
          <CardContent>
            <Center mb={4}>
              <Image src={serviceImg} alt={serviceName} />
             </Center>
          </CardContent>
        </Card>
      </Box>
    </>
  )
}

